import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import ResourcesLeft from '../Resources/Resources_Left'

function Main() {


    const ImageData = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Other/classroom.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Other/classroom7.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Other/classroom5.JPG" },

      

    ]

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Facilities" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>
                            <Col md={3} className='c-left custom-padding-color mb-4'>
                                <ResourcesLeft activeIndex={0} />
                            </Col>

                            <Col md={9} className='c-right c-lineheight2dot5 text-dark'>
                                <h3 className='c-headline mb-3'>Common Facilities </h3>
                                <p>Infrastructure was created from scratch in a very short period of time. The infrastructure at IIT Tirupati is comparable with that of the older IITs for the purpose of teaching the undergraduate courses. The building at the temporary campus was significantly modified to meet the requirements of IIT Tirupati. Several new installations were carried out to provide the students with an optimum environment for learning.</p>

                                <h3 className='c-headline mt-5 mb-3'>Classrooms</h3>
                                <p>Eight 60-seater classrooms and one 120-seater classroom were developed and the necessary furniture installed. All the classrooms were equipped with desktop computers with Internet access, projectors, screens and audio systems. To improve the acoustics, appropriate treatment has been done. A 120-seater virtual classroom was set up. Video conferencing facilities with a 1 Gbps bandwidth connection to the NKN were set up. 120-seater NKN classroom at IIT Tirupati</p>

                                <h3 className='c-headline mt-5 mb-3'>Our Gallery</h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {ImageData.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>                        
                                                <figure className="gallery-image">
                                                    <img src={item.img} alt="img" className="img" />
                                                </figure>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;